export interface VisualValidationFilters {
  groupDescriptionRef?: string;
  createdBy?: string;
}

export const VISUAL_VALIDATION_FILTER_KEYS: (keyof VisualValidationFilters)[] =
  ['groupDescriptionRef', 'createdBy'];
